<template>
  <b-modal
    id="asset-preview-modal"
    title="Preview"
    size="xl"
    centered
    body-class="select-folder-preview__body"
    :hide-footer="!hasDA"
  >
    <div class="select-folder-preview__layout">
      <div
        v-if="item"
        class="select-folder-preview__main"
      >
        <img
          class="select-folder-preview__img"
          :src="activeUrl"
          alt=""
        >
      </div>

      <div
        v-if="hasDA"
        class="select-folder-preview__thumbs"
      >
        <div
          v-for="(asset, index) in item.digital_assets"
          :key="asset.id"
          class="select-folder-preview__thumb-wrap"
        >
          <input
            type="checkbox"
            class="select-folder-preview__thumb-check"
            :checked="selectedAssetIds.includes(asset.id)"
            @change.stop="toggleAsset(asset)"
          >
          <img
            class="select-folder-preview__thumb"
            :class="{ active: activeIndex === index }"
            :src="asset.url"
            :alt="asset.name"
            @click="selectAsset(index)"
          >
        </div>
      </div>

      <b-alert
        v-if="!item"
        show
        variant="warning"
      >
        Preview is not available
      </b-alert>
    </div>
    <template #modal-footer>
      <b-button
        variant="primary"
        :disabled="selectedAssetIds.length === 0"
        @click="confirm"
      >
        Ok
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'AssetPreview',
  props: {
    item: {
      type: Object,
      default: null,
    },
    singleSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeUrl: null,
      activeIndex: 0,
      selectedAssetIds: [],
    };
  },
  computed: {
    hasDA() {
      return this.item?.digital_assets?.length > 0;
    },
  },
  watch: {
    item: {
      immediate: true,
      handler(val) {
        this.activeIndex = 0;
        this.selectedAssetIds = [];

        if (!val) {
          this.activeUrl = null;
          return;
        }

        if (val.digital_assets?.length > 0) {
          this.activeUrl = val.digital_assets[0].url;
        } else {
          this.activeUrl = val.asset_type === 'rapid_stock' ? val.url : val.path || null;
        }
      },
    },
  },
  methods: {
    show() {
      this.$bvModal.show('asset-preview-modal');
    },
    selectAsset(index) {
      this.activeIndex = index;
      this.activeUrl = this.item.digital_assets[index].url;
    },
    toggleAsset(asset) {
      if (this.singleSelect) {
        this.selectedAssetIds = this.selectedAssetIds[0] === asset.id ? [] : [asset.id];

        return;
      }

      const idx = this.selectedAssetIds.indexOf(asset.id);

      if (idx === -1) {
        this.selectedAssetIds = [...this.selectedAssetIds, asset.id];
      } else {
        this.selectedAssetIds = this.selectedAssetIds.filter((id) => id !== asset.id);
      }
    },
    confirm() {
      const assets = this.item.digital_assets.filter((a) => this.selectedAssetIds.includes(a.id));
      this.$emit('confirm-selection', assets);
      this.$bvModal.hide('asset-preview-modal');
    },
  },
};
</script>

<style scoped>
.select-folder-preview__layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.select-folder-preview__main {
  display: flex;
  justify-content: center;
}

.select-folder-preview__img {
  max-height: 450px;
  max-width: 100%;
  object-fit: contain;
}

.select-folder-preview__thumbs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.select-folder-preview__thumb-wrap {
  position: relative;
  display: inline-flex;
}

.select-folder-preview__thumb-check {
  position: absolute;
  top: 4px;
  left: 4px;
  z-index: 1;
  cursor: pointer;
}

.select-folder-preview__thumb {
  width: 80px;
  height: 80px;
  object-fit: contain;
  border: 2px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  background: #f5f5f5;

  &:hover {
    border-color: #9ca3af;
  }

  &.active {
    border-color: #16a38b;
  }
}
</style>
